"use client";

import dynamic from "next/dynamic";
import { useEffect, useRef, useState } from "react";

const CVReviewExample = dynamic(
  () => import("./cv-review-example").then((m) => m.CVReviewExample),
  { ssr: false },
);

// Mounts the interactive review example only when it scrolls near the viewport.
// It sits far below the fold, so deferring its hydration keeps it off the
// initial main-thread work (helps TBT/INP). A reserved min-height limits CLS.
export function CVReviewExampleLazy({
  showDetailed = true,
}: {
  showDetailed?: boolean;
} = {}) {
  const ref = useRef<HTMLDivElement>(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          setShow(true);
          io.disconnect();
        }
      },
      { rootMargin: "600px 0px" },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div ref={ref} style={show ? undefined : { minHeight: 600 }}>
      {show && <CVReviewExample showDetailed={showDetailed} />}
    </div>
  );
}
